/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../store/actions";
import Loader from "../component/loader";
import constants from "../helper/constants";
import store from "../store/store";
import AuthService from "../auth/authService";
import LogoutHelper from "../helper/logoutHelper";

class LogOut extends Component {
  componentDidMount() {
    LogoutHelper();
  }
  render() {
    return <Loader loading={true} top={"40%"} />;
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (profile) =>
      dispatch({ type: actionTypes.AUTHENTICATE, profile }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setTenantId: (id) => dispatch({ type: actionTypes.SET_TENANT_ID, id }),
    setTenantData: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_DATA, data }),
    setTenantLocale: (locale) =>
      dispatch({ type: actionTypes.SET_TENANT_LOCALE, locale }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LogOut);
